import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=6e142bae&scoped=true&"
import script from "./pass.vue?vue&type=script&lang=js&"
export * from "./pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e142bae",
  null
  
)

export default component.exports